import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, ToastController, NavParams, AlertController} from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';
import { HttpClient} from '@angular/common/http';
import { DataProvider } from '../../providers/data/data';

@IonicPage()
@Component({
  selector: 'page-companyInfo',
  templateUrl: 'companyInfo.html',
})
export class CompanyInfoPage {
  private GetUsers = [];
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    private data: DataProvider,
    private toastCtrl: ToastController,
    public httpClient: HttpClient,
    ) {

  }

  ionViewDidLoad() {
    document.getElementById('backmenu').style.display = 'block';
    document.getElementById('backFrom').innerText = '';
    this.data.currentTabName = 'Компани';
    this.rest.GetUsers(this.data.companyId).subscribe(res => {
      this.GetUsers = res;
    });
  }
  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }
  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/companyInfo/companyInfo.ts